// src/data/servicesData.ts
import { ChromaItem } from '../components/ChromaGrid/ChromaGrid';

export const servicesData: ChromaItem[] = [
  {
    image: "https://www.bbva.com/wp-content/uploads/2017/12/video-juegos-ordenador-diseno-desarrollo-programador-BBVA-1920x1080.jpg",
    title: "Desarrollo de Videojuegos",
    subtitle: "Experiencias de juego únicas y envolventes.",
    borderColor: "#8B5CF6", // Morado
    gradient: "linear-gradient(145deg, #8B5CF6, #100F15)",
  },
  {
    image: "https://universidadeuropea.com/resources/media/images/que-es-animacion-digital-1200x630.2e16d0ba.fill-767x384.jpg",
    title: "Producción y Animación Digital",
    subtitle: "Desde motion graphics hasta animaciones 3D.",
    borderColor: "#3B82F6", // Azul
    gradient: "linear-gradient(145deg, #3B82F6, #100F15)",
  },
  {
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNjAzNTV8MHwxfHNlYXJjaHwxfHxwcm9qZWN0JTIwbWFuYWdlbWVudHxlbnwwfHx8fDE3MjU1MTMyMTJ8MA&ixlib=rb-4.0.3&q=80&w=1080",
    title: "Gestión de Proyectos Multimedia",
    subtitle: "Coordinación integral para resultados de alto impacto.",
    borderColor: "#10B981", // Verde
    gradient: "linear-gradient(145deg, #10B981, #100F15)",
  },
  {
    image: "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNjAzNTV8MHwxfHNlYXJjaHwxfHx1aSUyMHV4fGVufDB8fHx8MTcyNTUxMzIzMHww&ixlib=rb-4.0.3&q=80&w=1080",
    title: "Diseño de Interfaces UI/UX",
    subtitle: "Interfaces intuitivas que mejoran la experiencia de usuario.",
    borderColor: "#F59E0B", // Amarillo
    gradient: "linear-gradient(145deg, #F59E0B, #100F15)",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjqdxoQhI1g0ZGutNhn2MCKdnhf8iNX77xdw&s",
    title: "Diseño Web",
    subtitle: "Sitios web personalizados, funcionales y responsivos.",
    borderColor: "#EF4444", // Rojo
    gradient: "linear-gradient(145deg, #EF4444, #100F15)",
  },
];